/**
 * The "Practice" menu. See lib/navigation/nav-manifest.js for the entry shape
 * and the vocabulary `requires` draws from.
 */

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const PRACTICE_ITEMS = [
  {
    href: "/simulator",
    label: "Practice Scenarios",
    shortcut: "S",
    iconName: "LiaTheaterMasksSolid",
    requires: "workspace",
  },
  {
    href: "/simulator/personas",
    label: "Personas",
    iconName: "IoPersonOutline",
    requires: "workspace",
  },
  {
    href: "/simulator/seller-personas",
    label: "Other Personas",
    iconName: "IoPeopleOutline",
    requires: ["workspace", "management", "supervisorOrAbove"],
  },
];
